import httpUtils from '@/utils/http-utils'
import {visitorApi} from '@/api/logs/index'
import {Source} from '@/utils/source'
import cookie from '@/assets/js/public/Cookie'
/*
101	事项指南
102	事项预约
103	事项申报
104	网上事项办理进度查询
105	居住证办理进度查询
106	出入境办理进度查询
107	重名查询
108	EMS查询
109	印章信息查询
110	开锁企业名录
111	公章刻制业名录
112	出入境中介机构名录
113	车辆违法查询
114	驾驶证记分查询
115	案件查询
116	保安员信息查询
117	身份证办理进度查询
118	寻人寻亲
119	失物招领
120	社区民警
121	路况信息
122	地图服务
123	实时路况
124	警务信息
125	预警防范
126	治安播报
127	政策解读
128	重大案件播报
129	公安动态
201	表单下载
202	咨询服务
203	微信报警
204	违法举报
205	线索举报
206	投诉举报
207	堵路移车
208	协查通报
209	通知公告
210	开锁求助
211	智能搜索
501	出入境业务查询缴费
502	户口办理进度查询
503	居住登记状态查询
504	交通线路查询
505	港澳台居民居住证受理点查询
506	中国驻外使领事联系方式查询
601	消防监督办事结果公开
602	查询报警处理结果
603	快撤直赔
604	流动人口信息登记
605	出租房屋信息登记
606	高速交警违法举报
607	出国期间护照遗失申报复函
608	便民缴费
609	交通违法缴费
610	交通违法处罚决定书缴费
701	我要挂失
702 我的证照
703 电子身份证
704 电子驾驶证
901	用户登录
902	注册用户
906	证照核验
907	容缺受理
 */

/*日志模块编码表：oi_statistics*/
export default {
  visit( logModule, logType, logBusData) {
    //初始化声明
    var logIp='', logCity='', _logAccountId='', _logBusData=''
    var logSource='WEI';
    if(Source.getSource()==="ANDROID"){
      logSource = 'ANDROID';
    }else if(Source.getSource()==="IOS"){
      logSource = "IOS";
    }
    if(logBusData){
      _logBusData=logBusData;
    }
    if(cookie.loginState()){
      _logAccountId=cookie.getUser().acountId
    }
    try{
      if(returnCitySN) {
        logIp=returnCitySN["cip"];

        logCity=returnCitySN["cname"];

      }
    } catch(error) {}

    //加入埋点日志
    var data = {
      "logIp":logIp,
      "logModule": logModule,
      "logSource":logSource,
      "logAccountId":_logAccountId,
      "logType":logType,
      "logCity":logCity,
      "logBusData":_logBusData,
      "logTimeStr":new Date().getFullYear()+'-'+((new Date().getMonth()+1)<10?'0'+(new Date().getMonth()+1):(new Date().getMonth()+1))+'-'+(new Date().getDate()<10?'0'+new Date().getDate():new Date().getDate())+ " "+
                  (new Date().getHours()<10?'0'+new Date().getHours():new Date().getHours())+ ":"+
                  (new Date().getMinutes()<10?'0'+new Date().getMinutes():new Date().getMinutes())+":"+
                  (new Date().getSeconds()<10?'0'+new Date().getSeconds():new Date().getSeconds())
    };
    httpUtils.postCommonUtils(visitorApi.burial_site_log,data).then((resp)=>{
      if(resp.data.succ){
       console.log("成功")
      }
    });
  }
}

